<template>
	<router-view></router-view>
</template>

<script>
	import axios from 'axios';
	import store from "./store";
	import router from "./router";

	export default {
		name: 'app',
		created: function () {
			axios.interceptors.response.use(undefined, function (err) {
				const {response} = err;
				return new Promise(function (resolve, reject) {
					if (response.status === 401) {
						store.dispatch('logout')
							.then(() => {
								router.push({name:'Logout'});
							});
					}
					throw err;
				});
			});
		}
	}
</script>

<style lang="scss">
	// CoreUI Icons Set
	@import '~@coreui/icons/css/coreui-icons.min.css';
	/* Import Font Awesome Icons Set */
	$fa-font-path: '~font-awesome/fonts/';
	@import '~font-awesome/scss/font-awesome.scss';
	/* Import Simple Line Icons Set */
	$simple-line-font-path: '~simple-line-icons/fonts/';
	@import '~simple-line-icons/scss/simple-line-icons.scss';
	/* Import Bootstrap Vue Styles */
	@import '~bootstrap-vue/dist/bootstrap-vue.css';
	// Import Main styles for this application
	@import 'assets/scss/style';
</style>
